/* Shared schema.org builders. CommonJS so both the React app (webpack) and prerender/build.js (Node) can use them. */

function organizationSchema(settings, origin) {
  const url = origin || (typeof window !== "undefined" ? window.location.origin : "https://renbsolutions.com");
  return {
    "@context": "https://schema.org",
    "@type": ["Organization", "ProfessionalService"],
    "@id": `${url}/#organization`,
    name: (settings && settings.site_name) || "RenB Solutions",
    alternateName: "Re-Engineering Business Solutions",
    legalName: "RenB Solutions",
    slogan: (settings && settings.tagline) || "Where Process Meets Progress",
    description:
      "RenB Solutions is a Mumbai-headquartered Business Process Management firm, founded and led by Vincent Fernandez, that works hands-on with SME founders and CEOs to re-engineer how their companies run: growth, transformation, strategy and leadership.",
    url,
    logo: settings && settings.logo_url ? settings.logo_url : undefined,
    email: settings && settings.contact_email ? settings.contact_email : undefined,
    telephone: settings && settings.phone ? settings.phone : undefined,
    founder: { "@type": "Person", name: "Vincent Fernandez", jobTitle: "Chairman & Founder" },
    address: {
      "@type": "PostalAddress",
      streetAddress: (settings && settings.address) || "10th Floor, Parinee Crescenzo, Bandra Kurla Complex, Bandra East",
      addressLocality: "Mumbai",
      postalCode: "400051",
      addressCountry: "IN",
    },
    areaServed: ["IN", "Worldwide"],
    knowsAbout: [
      "Business Process Management",
      "Business Process Re-engineering",
      "SME growth strategy",
      "Business transformation",
      "Strategy planning and execution",
      "Leadership and executive coaching",
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Practice series",
      itemListElement: [
        { "@type": "Service", name: "L Series: Business Growth Program", url: `${url}/services/business-growth` },
        { "@type": "Service", name: "M Series: Business Transformation Program", url: `${url}/services/business-transformation` },
        { "@type": "Service", name: "S Series: Strategy Planning & Execution Program", url: `${url}/services/strategy-planning-execution` },
        { "@type": "Service", name: "D Series: Leadership & Executive Coaching", url: `${url}/services/leadership-executive-coaching` },
      ],
    },
    sameAs: settings && settings.linkedin_url ? [settings.linkedin_url] : undefined,
  };
}

function faqSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (items || []).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

module.exports = { organizationSchema, faqSchema };
